import { useState, useCallback } from "react";

export const useSingleGroup = () => {
  const [groupFiles, setGroupFiles] = useState([]);

  /* add / remove -------------------------------------------------- */
  const addFiles = useCallback(
    (ids) => setGroupFiles((prev) => [...new Set([...prev, ...ids])]),
    []
  );

  const removeFiles = useCallback(
    (ids) => setGroupFiles((prev) => prev.filter((id) => !ids.includes(id))),
    []
  );

  const clearGroup = useCallback(() => setGroupFiles([]), []);

  return { groupFiles, addFiles, removeFiles, clearGroup };
};
